import { render, staticRenderFns } from "./Testablauf.vue?vue&type=template&id=592f5030"
import script from "./Testablauf.vue?vue&type=script&lang=js"
export * from "./Testablauf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports